import { ApolloError } from "apollo-boost"
import { ErrorResponse } from "apollo-link-error"
import { GraphQLError } from "graphql"
import { Maybe, ResponseErrorType } from "../../../graphql/generated-types"
import { Operation } from "apollo-link"
import { AppSectionEnum } from "../../types"

export const getApolloError = (apolloError: ApolloError | ErrorResponse, errorType: string): Maybe<GraphQLError> => {
    const graphqlError: Maybe<GraphQLError> =
        apolloError.graphQLErrors &&
        apolloError.graphQLErrors.find(
            // todo: refactor api to use just 'responseErrorType' property, not code
            (error) => error.extensions.responseErrorType === errorType || error.extensions.code === errorType
        )

    return graphqlError || null
}

export const getApolloBusinessError = (apolloError: ApolloError | ErrorResponse): Maybe<GraphQLError> => {
    const businessError: Maybe<GraphQLError> = getApolloError(apolloError, ResponseErrorType.BusinessError)

    return businessError || null
}

export const hasSpecificNetworkError = (apolloError: ApolloError | ErrorResponse, errorCode: string): boolean => {
    const networkError: Maybe<GraphQLError> =
        // @ts-ignore
        apolloError.networkError &&
        // @ts-ignore
        apolloError.networkError.result &&
        // @ts-ignore
        apolloError.networkError.result.errors &&
        // @ts-ignore
        apolloError.networkError.result.errors.find((error) => error.extensions.code === errorCode)

    return !!networkError
}

export const hasSpecificApolloError = (apolloError: ApolloError | ErrorResponse, errorCode: string): boolean =>
    !!getApolloError(apolloError, errorCode)

export const hasSpecificResponseError = (apolloError: ApolloError | ErrorResponse, errorCode: string) =>
    hasSpecificApolloError(apolloError, errorCode) || hasSpecificNetworkError(apolloError, errorCode)

export const shouldRetryRequest = (error: any, operation: Operation) => {
    const def = operation.query.definitions[0]
    return !!error && def && def.kind === "OperationDefinition" && def.operation === "query"
}

export const getBasePath = (p?: string) => {
    const path = p ?? window.location.pathname
    if (path === "/") {
        return ""
    }
    const regex = new RegExp(`/(${Object.values(AppSectionEnum).join("|")}).*`)
    return path.replace(regex, "")
}

export const parseBaseTenantUrlFromUrl = (url: Maybe<string>): Maybe<string> => {
    if (!url) {
        return null
    }
    if (url === "/") {
        return ""
    }
    const regex = new RegExp(`/(${Object.values(AppSectionEnum).join("|")}).*`)
    return url.replace(regex, "")
}
